import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export function getVotingSettingInputClasses({
  hasError,
  hasValue
}: {
  readonly hasError: boolean;
  readonly hasValue: boolean;
}) {
  const stateClasses = hasError ? "tw-caret-error tw-ring-error focus:tw-ring-error" : "tw-caret-primary-400 tw-ring-white/5 hover:tw-ring-white/10 focus:tw-ring-primary-400";
  const valueClasses = hasValue ? "tw-text-primary-400 focus:tw-text-white" : "tw-text-white";
  return `${stateClasses} ${valueClasses} tw-form-input tw-block tw-h-11 tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-black/20 tw-px-3 tw-py-2.5 tw-text-base tw-font-semibold tw-shadow-inner tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-bg-black/20 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset sm:tw-text-sm`;
}
export default function VotingSettingBox(t0) {
  const $ = _c(18);
  const {
    children,
    errorId,
    errorMessage,
    hasError,
    helpId,
    helpText,
    inputId,
    label
  } = t0;
  const stateClasses = hasError ? "tw-border-error tw-ring-error focus-within:tw-border-error focus-within:tw-ring-error" : "tw-border-white/5 tw-ring-white/5 hover:tw-border-white/10 hover:tw-ring-white/10 focus-within:tw-border-primary-400 focus-within:tw-ring-primary-400";
  const t1 = `${inputId}-setting`;
  const t2 = `${stateClasses} tw-rounded-xl tw-border tw-border-solid tw-bg-iron-900 tw-p-4 tw-shadow-inner tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  const t3 = `tw-mb-2 tw-block tw-text-sm tw-font-semibold ${hasError ? "tw-text-error" : "tw-text-iron-100"}`;
  let t4;
  if ($[0] !== inputId || $[1] !== label || $[2] !== t3) {
    t4 = <label htmlFor={inputId} className={t3}>{label}</label>;
    $[0] = inputId;
    $[1] = label;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== errorId || $[5] !== errorMessage || $[6] !== hasError) {
    t5 = hasError && <div id={errorId} className="tw-relative tw-flex tw-items-center tw-gap-x-2 tw-pt-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-relative tw-z-10 tw-text-xs tw-font-medium tw-text-error">{errorMessage}</div></div>;
    $[4] = errorId;
    $[5] = errorMessage;
    $[6] = hasError;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== helpId || $[9] !== helpText) {
    t6 = <p id={helpId} className="tw-mb-0 tw-mt-3 tw-text-sm tw-font-medium tw-leading-5 tw-text-iron-400">{helpText}</p>;
    $[8] = helpId;
    $[9] = helpText;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t1 || $[13] !== t2 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div data-testid={t1} className={t2}>{t4}{children}{t5}{t6}</div>;
    $[11] = children;
    $[12] = t1;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}